<div class="page-container">
  <div class="search-section">
    <div nz-row [nzGutter]="24" class="search-row">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="8" class="search-input-container">
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'tenant-list-search-input-group'">
          <input
            type="text"
            nz-input
            [placeholder]="'tenant.list.search-placeholder' | i18n"
            [(ngModel)]="searchKeywords"
            (keyup.enter)="search()"
            [testId]="'tenant-list-search-input'"
          />
          <ng-template #suffixIconSearch>
            <i
              nz-icon
              nzType="search"
              (click)="search()"
              nz-tooltip
              [nzTooltipTitle]="'tenant.list.search-tooltip' | i18n"
              class="search-icon"
              [testId]="'tenant-list-search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <button
          nz-button
          nzType="default"
          (click)="resetSearch()"
          class="reset-button"
          nz-tooltip
          [nzTooltipTitle]="'tenant.list.reset-tooltip' | i18n"
          [testId]="'tenant-list-reset-button'"
        >
          <i nz-icon nzType="clear" [testId]="'tenant-list-reset-icon'"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="filter-section" *ngIf="typeFilter || statusFilter">
    <div nz-row [nzGutter]="24">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" class="filter-tags-container">
        <div class="filter-tags">
          <nz-tag *ngIf="typeFilter" nzMode="closeable" [nzColor]="'blue'" (nzOnClose)="clearFilter('type')">
            {{ 'tenant.type' | i18n }}: {{ getTenantTypeLabel(typeFilter) }}
          </nz-tag>
          <nz-tag
            *ngIf="statusFilter"
            nzMode="closeable"
            [nzColor]="getTenantStatusColor(statusFilter)"
            (nzOnClose)="clearFilter('status')"
          >
            {{ 'common.status' | i18n }}: {{ getTenantStatusLabel(statusFilter) }}
          </nz-tag>
        </div>
      </div>
    </div>
  </div>

  <div class="table-section">
    <nz-table
      #basicTable
      class="content-table"
      [nzData]="listOfData"
      [nzLoading]="loading"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex"
      nzSize="small"
      [nzScroll]="{ x: '100%', y: 'calc(100vh - 200px)' }"
      [testId]="'tenant-list-table'"
    >
      <thead>
        <tr>
          <th scope="col" nzWidth="60px" nzLeft class="text-center row-number-column">{{ 'tenant.list.serial-number' | i18n }}</th>
          <th scope="col" *ngFor="let column of columns">
            {{ column.title }}
            <ng-container *ngIf="column.filterOptions">
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item *ngFor="let option of column.filterOptions" (click)="onFilterChange(column.key, option.value)">
                    {{ option.text }}
                  </li>
                  <li nz-menu-divider></li>
                  <li nz-menu-item (click)="clearFilter(column.key)">{{ 'common.reset' | i18n }}</li>
                </ul>
              </nz-dropdown-menu>
              <a nz-dropdown [nzDropdownMenu]="menu" class="filter-icon" [testId]="'tenant-list-filter-dropdown-' + column.key">
                <nz-icon
                  nzType="filter"
                  [nzTheme]="(column.key === 'type' && typeFilter) || (column.key === 'status' && statusFilter) ? 'fill' : 'outline'"
                />
              </a>
            </ng-container>
          </th>
          <th scope="col" nzRight>{{ 'tenant.list.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index" (dblclick)="editTenant(data)">
          <td nzLeft class="text-center row-number-column">{{ i + 1 }}</td>
          <td *ngFor="let column of columns; let colIndex = index">
            <ng-container *ngIf="column.key === 'type'; else statusOrNormalCell">
              <nz-tag [nzColor]="getTenantTypeColor(data[column.key])" [testId]="'tenant-list-type-tag'">
                {{ getTenantTypeLabel(data[column.key]) }}
              </nz-tag>
            </ng-container>

            <ng-template #statusOrNormalCell>
              <ng-container *ngIf="column.key === 'status'; else normalCell">
                <nz-tag [nzColor]="getTenantStatusColor(data[column.key])" [testId]="'tenant-list-status-tag'">
                  {{ getTenantStatusLabel(data[column.key]) }}
                </nz-tag>
              </ng-container>
            </ng-template>

            <ng-template #normalCell>
              <span class="truncate-text" [title]="data[column.key]">{{ data[column.key] }}</span>
            </ng-template>
          </td>
          <td nzRight class="action-column">
            <button
              nz-button
              nzType="primary"
              nzShape="circle"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'tenant.list.edit-tenant-tooltip' | i18n"
              class="action-button edit-button"
              (click)="editTenant(data)"
              [testId]="'tenant-list-edit-button'"
            >
              <nz-icon nzType="edit" nzTheme="outline" [testId]="'tenant-list-edit-icon'" />
            </button>
            <button
              nz-button
              nzType="primary"
              nzShape="circle"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'tenant.list.service-list-tooltip' | i18n"
              class="action-button service-button"
              (click)="viewServiceNumbers(data)"
              [testId]="'tenant-list-service-button'"
            >
              <nz-icon nzType="apartment" nzTheme="outline" [testId]="'tenant-list-service-icon'" />
            </button>
            <button
              *ngIf="canGrantPoints(data)"
              nz-button
              nzType="primary"
              nzShape="circle"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'tenant.list.point-grant-tooltip' | i18n"
              class="action-button point-button"
              (click)="openPointGrant(data)"
              [testId]="'tenant-list-point-grant-button'"
            >
              <nz-icon nzType="gift" nzTheme="outline" [testId]="'tenant-list-point-grant-icon'" />
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <div class="pagination-section" *ngIf="total > 0">
    <div class="pagination-info">{{ 'tenant.list.total-records' | i18n: { total: total } }}</div>
    <div class="pagination-controls">
      <nz-pagination
        nzSize="small"
        [nzShowQuickJumper]="true"
        [nzPageIndex]="pageIndex"
        [nzTotal]="total"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        (nzPageIndexChange)="nzPageIndexChange($event)"
        (nzPageSizeChange)="nzPageSizeChange($event)"
        [testId]="'tenant-list-pagination'"
      />
    </div>
  </div>

  <app-tenant-point-grant-drawer
    [visible]="pointGrantVisible"
    [tenant]="pointGrantTenant"
    (closed)="closePointGrant()"
    (completed)="loadData()"
  />
</div>
